import $ from 'jquery';

export default class Video {
    constructor() {
        if ($('.js-reveal').length) {
            $('body').on('closed.zf.reveal', function () {
                const $reveals = $('.js-reveal');

                $reveals.each(function() {
                    const $video = $(this).find('iframe');
                    const video_src = $video.attr('src');

                    $video.attr('src', '');
                    $video.attr('src', video_src);
                });
            });
        };
    };
};
